var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElevator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85086 3.11915H7.9591C8.13032 3.11915 8.26913 3.25797 8.26913 3.42919C8.26913 3.60041 8.13032 3.73922 7.9591 3.73922H5.85086C5.67964 3.73922 5.54082 3.60041 5.54082 3.42919C5.54082 3.25797 5.67964 3.11915 5.85086 3.11915Z",
    fill: "#023E8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1875 2.14754C2.1875 1.92799 2.36549 1.75 2.58504 1.75H11.2248C11.4444 1.75 11.6224 1.928 11.6224 2.14754V12.0275C11.6224 12.247 11.4444 12.425 11.2248 12.425H2.58504C2.36549 12.425 2.1875 12.247 2.1875 12.0275V2.14754ZM10.8273 11.6299V2.54507H2.98257V11.6299H3.96791V4.71064C3.96791 4.4911 4.1459 4.31311 4.36544 4.31311H9.44441C9.66395 4.31311 9.84195 4.4911 9.84195 4.71064V11.6299H10.8273ZM4.76298 5.10818V11.6299H6.50745V5.10818H4.76298ZM7.30252 5.10818V11.6299H9.04687V5.10818H7.30252Z",
    fill: "#023E8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator);
export default __webpack_public_path__ + "static/media/Elevator.0abc0e155348e1f48f4736f62f91a839.svg";
export { ForwardRef as ReactComponent };